var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEfi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.024 6.594C6.104 4.1 8.98 3 11.958 3h16.168a2.874 2.874 0 1 1 0 5.748H11.958c-1.514 0-2.678.518-3.518 1.526-.598.718-1.155 1.835-1.457 3.504h21.143a2.874 2.874 0 1 1 0 5.749H7.099c.959 3.536 3.636 4.49 4.858 4.49h16.168a2.874 2.874 0 1 1 0 5.75H11.958C7.354 29.767 1 25.822 1 16.653c0-4.193.996-7.625 3.024-10.059z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEfi);
export default __webpack_public_path__ + "static/media/EFI.0fe9e7d86c0073492ba246e4e22f0399.svg";
export { ForwardRef as ReactComponent };